import React, { useEffect } from 'react';
import { isNullOrUndefined } from '@utils/utils';
import { Dropdown } from '@components/RingilComponents/SafeDropdown';
import useCountries from '@hooks/use-countries/useCountries';
import { useTranslation } from 'react-i18next';
import { LovWithoutIdDTO } from '@api/ringil-api.v2.tsx';

interface ComponentProps {
  codeValue: string;
  onChange: (code: string) => void;
  style?: any;
  placeholder?: string;
  showClear?: boolean;
  required?: boolean;
  options?: LovWithoutIdDTO[];
}

const InputCountry: React.FC<ComponentProps> = ({ codeValue, onChange, style, placeholder, showClear = false, required = true, options }) => {
  const { t } = useTranslation('common');
  const coutries = useCountries();

  useEffect(() => {
    if ((isNullOrUndefined(codeValue) || codeValue === '') && required) {
      const preferedCountry = coutries.find(t => t.code === 'CZE');
      if (!isNullOrUndefined(preferedCountry)) {
        onChange(preferedCountry.code);
      }
    }
  }, [coutries]);

  return (
    <Dropdown
      style={style}
      options={options || coutries || []}
      optionLabel={'name'}
      optionValue={'code'}
      onChange={e => onChange(e.value)}
      value={codeValue}
      filter={true}
      placeholder={placeholder}
      showClear={showClear}
    />
  );
};

export default InputCountry;
